/** Origin кабинета для iframe-превью брендинга (§8) */
export const CABINET_ORIGIN: string =
  (import.meta.env.VITE_CABINET_ORIGIN as string | undefined) ??
  (import.meta.env.DEV ? 'http://localhost:5173' : 'https://cabinet.buildex.com');
